// extracted by mini-css-extract-plugin
var _1 = "JL7WO9HbZapMsyTFIRF5";
export { _1 as "hint" }
